var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Update Password")]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "grid",
        attrs: { novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.updatePassword($event)
          }
        }
      },
      [
        _c(
          "label",
          { staticClass: "reader-only", attrs: { for: "UpdatePasswordEmail" } },
          [_vm._v("Email Address")]
        ),
        _vm._v(" "),
        _c("input", {
          attrs: {
            autocomplete: "email",
            id: "UpdatePasswordEmail",
            name: "UpdatePasswordEmail",
            type: "hidden"
          },
          domProps: { value: _vm.$store.state.userProfile.email_address }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid__row" }, [
          _c("div", { staticClass: "grid__col grid__col--100" }, [
            _c(
              "label",
              {
                staticClass: "reader-only",
                attrs: { for: "UpdatePasswordCurrent" }
              },
              [_vm._v("Current Password")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.currentPassword,
                  expression: "currentPassword",
                  modifiers: { trim: true }
                },
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required",
                  expression: "'required'",
                  modifiers: { disable: true }
                }
              ],
              class: {
                "input--invalid": _vm.errors.has("UpdatePasswordCurrent")
              },
              attrs: {
                autocomplete: "current-password",
                autofocus: "",
                id: "UpdatePasswordCurrent",
                name: "UpdatePasswordCurrent",
                placeholder: "Current Password",
                type: "password"
              },
              domProps: { value: _vm.currentPassword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.currentPassword = $event.target.value.trim()
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("UpdatePasswordCurrent")
              ? _c("span", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_vm.errors.first("UpdatePasswordCurrent")))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid__row" }, [
          _c("div", { staticClass: "grid__col grid__col--100" }, [
            _c(
              "label",
              {
                staticClass: "reader-only",
                attrs: { for: "UpdatePasswordNew" }
              },
              [_vm._v("New Password (min 8 characters)")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.newPassword,
                  expression: "newPassword",
                  modifiers: { trim: true }
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:8",
                  expression: "'required|min:8'"
                }
              ],
              ref: "UpdatePasswordNew",
              class: { "input--invalid": _vm.errors.has("UpdatePasswordNew") },
              attrs: {
                autocomplete: "new-passsword",
                id: "UpdatePasswordNew",
                name: "UpdatePasswordNew",
                placeholder: "New Password (min 8 characters)",
                type: "password"
              },
              domProps: { value: _vm.newPassword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newPassword = $event.target.value.trim()
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("UpdatePasswordNew")
              ? _c("span", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_vm.errors.first("UpdatePasswordNew")))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid__row" }, [
          _c("div", { staticClass: "grid__col grid__col--100" }, [
            _c(
              "label",
              {
                staticClass: "reader-only",
                attrs: { for: "UpdatePasswordConfirm" }
              },
              [_vm._v("Confirm New Password")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required|confirmed:UpdatePasswordNew",
                  expression: "'required|confirmed:UpdatePasswordNew'",
                  modifiers: { disable: true }
                }
              ],
              ref: "UpdatePasswordConfirm",
              class: {
                "input--invalid": _vm.errors.has("UpdatePasswordConfirm")
              },
              attrs: {
                autocomplete: "new-password",
                id: "UpdatePasswordConfirm",
                name: "UpdatePasswordConfirm",
                placeholder: "Confirm New Password",
                type: "password"
              }
            }),
            _vm._v(" "),
            _vm.errors.has("UpdatePasswordConfirm")
              ? _c("span", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_vm.errors.first("UpdatePasswordConfirm")))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid__row" }, [
          _c("div", { staticClass: "grid__col grid__col--100" }, [
            _c(
              "button",
              {
                staticClass: "submit",
                attrs: { type: "submit", disabled: _vm.isUpdating }
              },
              [_vm._v("Change Password")]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }